/* globals GIG */

'use strict';

const EventPipe = require('../../deal/frontend/event_pipe');

const addToCartButtonClickHandler = function addToCartButtonClickHandler(fn) {
  const $addToCartButton = document.querySelector(
    '.add-cart-button #add-to-cart'
  );
  if (!$addToCartButton) return;
  $addToCartButton.addEventListener('click', event => {
    const result = this.eventPipe.trigger('buy_button_clicked', event);
    if (fn) {
      fn(result, event);
    }
  });
};

const addBuyButtonClickHandler = function addBuyButtonClickHandler(fn) {
  const $buyButtons = document.querySelectorAll(
    '.buy-button .buy, .gift-button'
  );
  $buyButtons.forEach($buyButton => {
    $buyButton.addEventListener('click', event => {
      const result = this.eventPipe.trigger('buy_button_clicked', event);
      if (fn) {
        fn(result, event);
      }
    });
  });

  this.eventPipe.on('buy_button_clicked', event => {
    if (
      event.currentTarget &&
      event.currentTarget.classList.contains('gift-button')
    ) {
      return { isGift: true };
    }
    return null;
  });

  if (this.data.hasMultiOption) {
    this.eventPipe.on('buy_button_clicked', () => {
      const selectedMultiOption = document.querySelector(
        '.m-option-b.inline-list input:checked'
      );

      if (!selectedMultiOption) {
        return null;
      }

      const {
        dataset: { uuid: optionUuid },
        value: buyUrl,
      } = selectedMultiOption;

      return { optionData: { buyUrl, optionUuid } };
    });
  }
};

const addOptionsClickHandler = function addOptionsClickHandler() {
  const $optionLists = document.querySelectorAll('.m-option-b');

  const { dealUuid } = this.data;
  $optionLists.forEach($list => {
    const isInline = $list.classList.contains('inline-list');

    $list.addEventListener('click', event => {
      if (event.target.classList.contains('deal-option')) {
        const { uuid: optionUuid } = event.target.dataset;
        const buyUrl = event.target.value;
        this.eventPipe.trigger('option_updated', {
          buyUrl,
          dealUuid,
          isInline,
          isOverlay: !isInline,
          optionUuid,
        });
      }
    });
  });
};

const openGoodsWarrantyModal = function openGoodsWarrantyModal() {
  const $goodsWarrantyModalCta = document.querySelector('.add-warranty-cta');
  const $goodsWarrantyModal = document.querySelector('#goods-warranty-modal');

  $goodsWarrantyModal.dataset.fromBuy = true;
  $goodsWarrantyModalCta.style.display = 'block';
  GIG.Modal.open({ id: 'goods-warranty-modal' });
};

const handleGoodsWarrantyModalClose = function handleGoodsWarrantyModalClose(
  sendToCheckoutOrNull
) {
  if (!this.sourceBuyEvent) return;

  const $goodsWarrantyModal = document.querySelector('#goods-warranty-modal');
  const $goodsWarrantyModalCta = document.querySelector('.add-warranty-cta');

  $goodsWarrantyModalCta.style.display = 'none';

  if ($goodsWarrantyModal.dataset.toPurchase) {
    const result = this.eventPipe.trigger(
      'buy_button_clicked',
      this.sourceBuyEvent
    );
    sendToCheckoutOrNull(result, this.sourceBuyEvent);
  } else {
    delete $goodsWarrantyModal.dataset.fromBuy;
    this.hideProcessingLoader(this.sourceBuyEvent);
  }
};

const addEventPipe = function addEventPipe() {
  this.eventPipe = new EventPipe();
  window.BuyButtonEventPipe = this.eventPipe;
};

module.exports = {
  addEventPipe,
  addBuyButtonClickHandler,
  addOptionsClickHandler,
  addToCartButtonClickHandler,
  openGoodsWarrantyModal,
  handleGoodsWarrantyModalClose,
};
